var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Cookies from 'js-cookie';
import { matchRoutes } from 'react-router-config';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import isIE from 'is-iexplorer';
import NotFound from 'src/components/layouts/ResourseNotFound/OrgNotFound';
import BrowserNotSupported from 'src/components/layouts/ResourseNotFound/BrowserNotSupported';
var redirect = false;
var isDevStage = window.location.href.indexOf('localhost') !== -1 ||
    window.location.href.indexOf(':3000') !== -1 ||
    window.location.href.indexOf('tt-react-dev') !== -1 ||
    window.location.href.indexOf('tt-react-test') !== -1 ||
    window.location.href.indexOf('.dev.trainingtube.com') !== -1;
var isLocalStage = window.location.href.indexOf('localhost') !== -1 || window.location.href.indexOf(':3000') !== -1;
var Authorization = /** @class */ (function (_super) {
    __extends(Authorization, _super);
    function Authorization(props) {
        var _this = _super.call(this, props) || this;
        var location = props.location;
        _this.state = { loading: true };
        if (location.pathname !== '/' &&
            location.pathname !== '/login' &&
            location.pathname !== '/register' &&
            location.pathname !== '/reset-password' &&
            location.pathname !== '/forgot-password' &&
            location.pathname !== '/loginembed' &&
            location.pathname !== '/login-lp' &&
            location.pathname !== '/lp' &&
            location.pathname !== '/auto-login') {
            Cookies.set('prevLocation', location.pathname, { expires: 0.05 });
        }
        return _this;
    }
    Authorization.prototype.componentDidMount = function () {
        if (this.props.isOrgPresent) {
            this.checkAuth();
        }
    };
    Authorization.prototype.componentDidUpdate = function (prevProps) {
        /**
         * If route is changed
         * Update auths
         */
        if (!_.isEqual(this.props.location.pathname, prevProps.location.pathname)) {
            if (prevProps.location.pathname !== '/' &&
                prevProps.location.pathname !== '/login' &&
                prevProps.location.pathname !== '/register' &&
                prevProps.location.pathname !== '/reset-password' &&
                prevProps.location.pathname !== '/forgot-password' &&
                prevProps.location.pathname !== '/loginembed' &&
                prevProps.location.pathname !== '/auto-login' &&
                prevProps.location.pathname !== '/lp' &&
                prevProps.location.pathname !== '/login-lp') {
                Cookies.set('prevLocation', prevProps.location.pathname, { expires: 0.05 });
            }
            if (this.props.isOrgPresent) {
                this.checkAuth();
            }
        }
    };
    Authorization.prototype.checkAuth = function () {
        var _this = this;
        var matched = matchRoutes(this.props.routes, this.props.location.pathname)[0];
        if (matched && matched.route.auth && matched.route.auth.length > 0) {
            if (!matched.route.auth.includes(this.props.user.role)) {
                var prevLocation = Cookies.get('prevLocation');
                redirect = true;
                if (this.props.user.role === 'guest') {
                    var redirectUrl = prevLocation || this.props.location.pathname;
                    Cookies.set('prevLocation', redirectUrl, { expires: 0.1 });
                    if (isLocalStage) {
                        return (window.location.href = '/login?redirect=' + window.location.pathname);
                    }
                    var devParam = isDevStage ? '&isDev=true' : '';
                    window.location.href =
                        'https://www.trainingtube.com/login?redirectTo=' +
                            window.location.pathname +
                            '&commingFrom=' +
                            this.props.domain +
                            devParam;
                }
                else {
                    var redirect_1 = getParameterByName('redirect');
                    var redirectUrl = redirect_1 || prevLocation;
                    setImmediate(function () {
                        _this.setState({
                            loading: false,
                        });
                    });
                    this.props.history.push({
                        pathname: redirectUrl || '/',
                    });
                }
            }
        }
        this.setState({
            loading: false,
        });
    };
    Authorization.prototype.shouldComponentUpdate = function () {
        if (redirect) {
            redirect = false;
            return false;
        }
        else {
            return true;
        }
    };
    Authorization.prototype.render = function () {
        var _a = this.props, children = _a.children, isOrgPresent = _a.isOrgPresent;
        if (isIE) {
            return React.createElement(BrowserNotSupported, null);
        }
        if (!isOrgPresent) {
            return React.createElement(NotFound, null);
        }
        if (this.state.loading) {
            return (React.createElement("div", { id: "fuse-splash-screen" },
                React.createElement("div", { className: "center" },
                    React.createElement("div", { className: "logo" },
                        React.createElement("img", { width: "128", src: "assets/images/logos/icon-logo.png", alt: "logo" })),
                    React.createElement("div", { className: "spinner-wrapper" },
                        React.createElement("h6", { className: "text-center title" },
                            "Have you tried to use ",
                            React.createElement("strong", null, "Training Tube "),
                            " to ..."),
                        React.createElement("p", { className: "text-center semi-title" }, "Documenting specification for new software features ?"),
                        React.createElement("p", { className: "text-center semi-title" }, "It's 10X faster than written document")),
                    React.createElement("div", { className: "spinner-wrapper" },
                        React.createElement("div", { className: "spinner" },
                            React.createElement("div", { className: "inner" },
                                React.createElement("div", { className: "gap" }),
                                React.createElement("div", { className: "left" },
                                    React.createElement("div", { className: "half-circle" })),
                                React.createElement("div", { className: "right" },
                                    React.createElement("div", { className: "half-circle" }))))))));
        }
        return React.createElement(React.Fragment, null, children);
    };
    return Authorization;
}(React.Component));
function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch);
}
function mapStateToProps(_a) {
    var auth = _a.auth;
    return {
        user: auth.user,
        domain: auth.organization.domain,
    };
}
function getParameterByName(name, url) {
    if (!url)
        url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'), results = regex.exec(url);
    if (!results)
        return null;
    if (!results[2])
        return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Authorization));



//////////////////
// WEBPACK FOOTER
// ./src/theme/components/Authorization.tsx
// module id = 2018
// module chunks = 81